export default class Locale_ResourceSettings { 
	ResourceProperties: string = 'Resource Properties';
	MissingRelatedGenericResource: string = "Saved resource is missing a related generic resource.";
	ResourcesSaved: string = "Resource saved!";
}